import { CategorySection } from '@/components/CategorySection';
import { AppHeader } from '@/components/AppHeader';
import { AppSidebar } from '@/components/AppSidebar';
import { useCategories } from '@/hooks/useCategories';
import { useCategoryDrop } from '@/hooks/useCategoryDrop';
import { useAuth } from '@/hooks/useAuth';
import { useAccounts } from '@/hooks/useAccounts';
import { SidebarProvider } from '@/components/ui/sidebar';

const Index = () => {
  const { user } = useAuth();

  const {
    categories,
    expanded,
    handleToggle,
    handleAddCategory,
    handleEditCategory,
    handleReorderCategories,
    setCategories,
  } = useCategories();

  const {
    accounts,
    addAccount,
    removeAccount,
    setAccounts,
  } = useAccounts();

  const {
    handleDrop,
    handleRemoveAccount,
  } = useCategoryDrop(
    setCategories,
    removeAccount,
    addAccount,
    accounts
  );

  if (!user) {
    return null;
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar 
          categories={categories}
          accounts={accounts}
          expanded={expanded}
          onToggle={handleToggle}
          onSetAccounts={setAccounts}
          setCategories={setCategories}
        />
        <div className="flex-1 flex flex-col overflow-hidden">
          <AppHeader />
          <div className="flex-1 container mx-auto py-1 px-2 overflow-hidden max-w-[150%]">
            <div className="h-[calc(100vh-8rem)] relative">
              <div className="rounded-sm overflow-y-auto h-full">
                <CategorySection
                  categories={categories}
                  accounts={accounts}
                  onDrop={handleDrop}
                  expanded={expanded}
                  onToggle={handleToggle}
                  onAddCategory={handleAddCategory}
                  onEditCategory={handleEditCategory}
                  onReorderCategories={handleReorderCategories}
                  onRemoveAccount={handleRemoveAccount}
                  onSetAccounts={setAccounts}
                  setCategories={setCategories}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Index;
